import React, { useEffect, Fragment, useState } from "react";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import {
  Type,
  Divider,
  Flex,
  Skeleton,
} from "discover.medical.react-component-library";
import { useDispatch, useStore } from "../../store";
import { fetchAlerts } from "../../store/actions/alerts";
import { fetchCategories } from "../../store/actions/alertCategories";
import ErrorBoundary from "../ErrorBoundary";
import CategoryDialog from "./CategoryDialog";
import AlertItems from "../Alerts/AlertItems";
import { ButtonFilter } from "discover.medical.react-component-library";

export const AllAlerts = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAlerts(dispatch);
    fetchCategories(dispatch);
  }, [dispatch]);

  const { all, isFetching } = useStore().alerts || {};
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const configData = useConfig();
  const isPersonalized = configData?.header.userDetails.state.personalized;

  const handleFilterButtonClick = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  return (
    <ErrorBoundary>
      <Type element="h1" fontFamily="secondary" color="gray800">
        Recent Alerts
      </Type>
      <Divider />
      <Flex container align={{ item: "center" }}>
        <Type marginRight="md" style={{ whiteSpace: "nowrap" }}>
          Filter by
        </Type>
        <ButtonFilter
          children="Category"
          onClick={handleFilterButtonClick}
          selected={selectedCategories.length > 0}
        />
        <CategoryDialog
          isOpen={isDialogOpen}
          setIsOpen={setIsDialogOpen}
          defaultSelected={selectedCategories}
          setDefaultSelected={setSelectedCategories}
        />
      </Flex>
      <Divider />
      {isFetching ? (
        [...Array(6).keys()].map((item) => (
          <Fragment key={item}>
            <Skeleton kind="text" rag animate width={250} />
            <Skeleton kind="text" rag animate />
            <Skeleton kind="text" rag animate />
            <Skeleton kind="text" rag animate width={400} marginBottom="lg" />
          </Fragment>
        ))
      ) : (
        <>
          {all?.unfiltered?.length > 0 ? (
            <AlertItems
              data-testid="all-alert-items"
              alerts={all}
              renderSubscribeCard={!isPersonalized}
              showFilters={false}
            />
          ) : (
            <Type element="p" marginBottom="md">
              There are no recent alerts to display.
            </Type>
          )}
        </>
      )}
    </ErrorBoundary>
  );
};

export default AllAlerts;
